import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { AuthService } from "@data/services/modules/auth/auth.service";
import { environment } from 'environments/environment';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

	constructor(
		private authService: AuthService,
		private router: Router
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const currentUser = this.authService.getUser;
		const isLoggedIn = currentUser && currentUser.token;
		const isApiUrl = request.url.startsWith(environment.apiUrl);
		const isUploadRequest = request.url.includes('documents/upload');
		const isAuthRequest = request.url.includes('/auth/login') || request.url.includes('/auth/register') || request.url.includes('/auth/forgot-password');

		if (isLoggedIn && isApiUrl) {
			request = request.clone({
				setHeaders: {
					'Authorization': `Bearer ${currentUser.token}`,
					//! Con guion MEDIO porque el bajo no llega: nginx descarta por defecto las cabeceras
					//! con guion bajo, así que `refresh_token` funcionaba en local y se perdía en cuanto
					//! había un proxy de por medio. Medido el 11-sep-2026 contra localhost y contra el
					//! ingress de dev con la misma petición. Por eso la sesión moría a las 3 h en punto
					//! en los entornos desplegados y nunca al desarrollar.
					'refresh-token': currentUser.detailToken.refreshToken,
					//* Se sigue mandando la vieja por si la API que contesta todavía es la anterior.
					'refresh_token': currentUser.detailToken.refreshToken,
				},
			});
		}

		if (!isLoggedIn && !isAuthRequest) {
			if (isUploadRequest) {
				console.error('❌ [UPLOAD DEBUG] - Usuario no autenticado para upload');
			}
			this.authService.logout();
			this.router.navigate(['/login']);
		}

		return next.handle(request).pipe(
			//! B-044 · El backend rota el token cuando el que mandamos ya venció, y desde ahora lo
			//! devuelve en estas cabeceras (`jwt.guard.ts`). Guardarlo aquí es lo que mantiene viva la
			//! sesión de quien está trabajando: sin esto el navegador conservaba el vencido para
			//! siempre y cada petición volvía a pagar un `generateJWT` completo contra Mongo.
			//!
			//! Solo se leen si el CORS las expone — `main.ts` ya declara las dos en `exposedHeaders`.
			//! Si algún día se quitan de ahí, esto deja de recibir nada **sin fallar**, que es la forma
			//! más cara de romperse.
			tap((event) => {
				if (!(event instanceof HttpResponse)) return;
				const accessToken = event.headers.get('access-token') ?? event.headers.get('access_token');
				const refreshToken = event.headers.get('refresh-token') ?? event.headers.get('refresh_token');
				if (accessToken) this.authService.guardarTokens(accessToken, refreshToken ?? undefined);
			})
		);
	}
}
